import { Admission } from '@domain/admission';
import { formatCurrency } from '@utils/price-formatter/format-currency';

import { calculateDDP } from './calculate-ddp';

export const formatDDP = ({ offer, quantity }: { offer: Admission; quantity: number }) => {
  const currency = offer.price.currency;
  const number = calculateDDP(offer) * quantity;
  return formatCurrency({
    number,
    currency,
  });
};
